import { BetBuilderFixture } from '@cds/betting-offer/domain-specific/bet-builder';
import { PopularBetsOptionTeamInfo } from '@cds/betting-offer/domain-specific/popular-bets';
import { EventParticipant, EventParticipantImage, SportModel } from '@frontend/sports/betting-offer/feature/model';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { TrackingSource } from '@frontend/sports/tracking/feature';
import {
    BetBuilderBadgePosition,
    PopularBetsPodBackgroundImage,
    PopularBetsPodTheme,
    PopularBetsPodTypes,
} from '@frontend/sports/types/components/popular-bets';

import { BetBuilderMarket } from '../bet-builder/model/bet-builder.model';

export enum AddToBetslipState {
    Default = 'default',
    Disabled = 'disabled',
    Selected = 'selected',
    Locked = 'locked',
}

export enum PickSelectionType {
    Single = 'single',
    All = 'all',
}

export type PopularBetsLogoTypes = 'TeamLogo' | 'CompetitionLogo' | 'SportsLogo' | 'ShieldIcon' | 'EmptyIcon' | 'OpenBullets' | 'RadioOff';

export interface PopularBetsPodEventLogoDetails {
    logoType: PopularBetsLogoTypes;
    participantLogo?: EventParticipantImage;
    fallbackLogoUrl?: string;
}

export interface MultiBetsViewModel {
    payload: PodEventsModel[];
    title: string;
    titleIconClass: string;
    minHeight: number;
    minWidth: number;
    showHeader: boolean;
}

export interface PodEventsModel {
    events: GridEvent[];
    counter: number;
    sport: SportModel | undefined;
    expand: boolean;
    visibleOptionsLimit: number;
    showMoreLessButtonVisible: boolean;
    showOptionPick: boolean;
    eventsCount: number;
    eventsHideCount?: number;
    podId?: string;
    tracking: TrackingSource;
    title?: string;
    eventStartDate?: Date;
    defaultNoOfLegs: number;
    isOptionPickEnabled: boolean;
    podType: PopularBetsPodTypes;
    isAllPodAreSameType: boolean;
    preCreatedMarket?: { [key: string]: BetBuilderMarket };
    preCreatedOptions?: IPreCreatedOption[];
    preCreatedOffer?: BetBuilderFixture[];
    summary?: string;
    betBuilderBadgePosition: BetBuilderBadgePosition;
    backgroundStyle?: string;
    enableLogoHeader: boolean;
    backgroundImage?: PopularBetsPodBackgroundImage;
    podTheme: PopularBetsPodTheme;
    titleColor?: string;
    podOptionTeamInfo: PopularBetsOptionTeamInfo[];
}

export interface IPreCreatedOption {
    name: string;
    optionId: number;
    fixtureId: string;
    logoDetails: PopularBetsPodEventLogoDetails;
    opponentParticipant?: EventParticipant;
    type: BetBuilderOptionType;
}

export interface IExpandCollapse {
    isExpanded: boolean;
    noOfLegs: number;
}

export interface ButtonProperties {
    state: AddToBetslipState;
    text: string;
}

export interface IPodHeightConfigModel {
    rows: number;
    isEpcotEnabled: boolean;
    podType: PopularBetsPodTypes;
    isAllPodAreSameType: boolean;
    showOptionPick: boolean;
    isAnyPodHasSummary?: boolean;
}

export enum BetBuilderOptionType {
    Group = 'Group',
    Market = 'Market',
}
